import { render, staticRenderFns } from "./azurestorage.vue?vue&type=template&id=904a4264&"
import script from "./azurestorage.vue?vue&type=script&lang=js&"
export * from "./azurestorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports